import { __assign } from "tslib";
export function getStateNameProps(state, locStrings) {
    var _a, _b, _c;
    var result = {
        state: state ? state.toLowerCase() : 'empty',
        toolTip: (_a = locStrings === null || locStrings === void 0 ? void 0 : locStrings.manageStorage) !== null && _a !== void 0 ? _a : '',
    };
    switch (state.toLowerCase()) {
        case 'empty':
        case 'normal':
            return result;
        case 'nearing':
        case 'critical':
            return __assign(__assign({}, result), { toolTip: (_b = locStrings === null || locStrings === void 0 ? void 0 : locStrings.criticalStateTooltip) !== null && _b !== void 0 ? _b : '' });
        case 'full':
        case 'over':
        case 'overLimit':
            return __assign(__assign({}, result), { toolTip: (_c = locStrings === null || locStrings === void 0 ? void 0 : locStrings.fullStateTooltip) !== null && _c !== void 0 ? _c : '' });
    }
    return result;
}
//# sourceMappingURL=getStateNameProps.js.map